import { render, staticRenderFns } from "./UploadDriverModal.vue?vue&type=template&id=48f5a4e2"
import script from "./UploadDriverModal.vue?vue&type=script&lang=ts"
export * from "./UploadDriverModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadDriverModal.vue?vue&type=style&index=0&id=48f5a4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports